/* eslint-disable */
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import BusinessIcon from '@material-ui/icons/Business';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import withServices from '../../Contexts/Services/WithServices.context';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Accounts.page.i18n';
import AccountsPagePropTypes from './Accounts.page.props';
import AccountsPageSidebar from './Accounts.page.sidebar';
import accountsPageStyles from './Accounts.page.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * AccountsPageComponent
 * @export
 * @class AccountsPageComponent
 * @extends {React.Component<AccountsPageComponentComposedProps, AccountsPageComponentState>}
 */
export class AccountsPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<AccountsPageComponentProps>}
   * @memberof AccountsPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`AccountsPage`}
   * @memberof AccountsPageComponent
   */
  static displayName = `AccountsPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof AccountsPageComponent
   */
  static propTypes = AccountsPagePropTypes;

  /**
   * Data specific to the `<AccountsPage />` instance
   * @type {AccountsPageComponentState}
   * @memberof AccountsPageComponent
   */
  state = {};

  /**
   * When the Component mounts, retrieve user accounts
   * @returns {void} void
   * @memberof AccountsPageComponent
   */
  async componentDidMount() {
    const { services } = this.props;
    // get array of billTo numbers
    const billToAccounts = services.authService.getGroups();
    // request user accounts
    let { accounts } = await services.userService.getUserAccounts();
    if (!accounts) {
      accounts = [];
    } else {
      // map billToNumbers to accounts and return structure that we can use to render
      accounts = billToAccounts.map((billToAccount) => {
        const foundAccount = accounts.find((account) => {
          return helpers.getNumberFromBillTo(billToAccount) === account.CustomerCode.trim();
        });
        if (foundAccount) {
          return {
            accountName: foundAccount.AccountName,
            billTo: billToAccount,
          };
        }
        // no matching account name then as a backup display billTo number
        return {
          accountName: billToAccount,
          billTo: billToAccount,
        };
      });
    }
    this.setState({
      accounts,
    });
  }

  /**
   * Render the accounts
   * @returns {React.Component} The rendered accounts
   * @memberof AccountsPageComponent
   */
  renderAccounts() {
    const { classes } = this.props;
    const { accounts } = this.state;
    if (!accounts) {
      return null;
    }
    return accounts.map((account) => {
      const url = `/account/${helpers.getNumberFromBillTo(account.billTo)}`;
      return (
        <Grid container item key={account.billTo} sm={8} xs={12}>
          <Grid alignItems="center" classes={{ container: classes.accountBillTo }} container item spacing={2} wrap="nowrap">
            <Grid item>
              <Avatar>
                <BusinessIcon />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="caption">
                <Link className={classes.link} to={url}>
                  {helpers.getUserTypeFromBillTo(account.billTo) === `super` ? `Super User` : `Standard User`}
                </Link>
              </Typography>
              <Typography variant="subtitle1" data-mf-replace-inner={MFSDR}>
                <Link className={classes.link} to={url}>
                  <span className={classes.textDecorationUnderline}>{account.accountName}</span>
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      );
    });
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<AccountsPage />`
   * @memberof AccountsPageComponent
   */
  render() {
    const { classes, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <Page
        className={classes.root}
        heading="AccountsPage.PageTitle"
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        overflow="auto"
        sidebarContent={<AccountsPageSidebar />}
        title="AccountsPage.PageTitle"
      >
        {this.renderAccounts()}
      </Page>
    );
  }
}

/** @type {React.ComponentClass<AccountsPageComponentProps>} */
const AccountsPage = compose(
  withWidth(),
  withRouter,
  withServices,
  withStyles(themeCreateInjectableStyles(accountsPageStyles), { withTheme: true }),
)(AccountsPageComponent);

export default AccountsPage;
